module.exports = __webpack_public_path__ + "img/RZ_Handel_D_2_2022_final - Thumbnail.5631bffd.png";